import { lazy } from 'react';

const FormItem = lazy(() => import('./FormItem'));

export { FormItem };
